import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "search-trigger-text" }
const _hoisted_2 = { class: "shell-value" }
const _hoisted_3 = {
  key: 0,
  class: "search-trigger-keys"
}
const _hoisted_4 = { class: "search-field" }
const _hoisted_5 = {
  ref: "list",
  class: "search-results"
}
const _hoisted_6 = {
  key: 0,
  class: "search-note"
}
const _hoisted_7 = {
  key: 1,
  class: "search-note"
}
const _hoisted_8 = { class: "search-group-name" }
const _hoisted_9 = { class: "search-group-count" }
const _hoisted_10 = { class: "search-title" }
const _hoisted_11 = {
  key: 0,
  class: "search-why"
}
const _hoisted_12 = { class: "search-why-field" }
const _hoisted_13 = {
  key: 1,
  class: "search-why-text"
}
const _hoisted_14 = {
  key: 2,
  class: "search-why-text"
}
const _hoisted_15 = {
  key: 0,
  class: "search-hints"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_ontos_count = _resolveComponent("ontos-count")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_ontos_colored_value = _resolveComponent("ontos-colored-value")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$vuetify.display.xs)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          variant: "text",
          size: "small",
          icon: "mdi-magnify",
          "aria-label": _ctx.$tt('search.open'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open()))
        }, null, 8, ["aria-label"]))
      : (_openBlock(), _createBlock(_component_v_btn, {
          key: 1,
          variant: "text",
          class: "shell-trigger shell-plain-case",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              start: "",
              size: "small"
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("mdi-magnify", -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_1, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$tt('search.open')), 1),
              (_ctx.$vuetify.display.mdAndUp)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.keys), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.asking,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.asking) = $event)),
      "max-width": 720,
      fullscreen: _ctx.$vuetify.display.smAndDown,
      scrollable: "",
      onAfterEnter: _cache[7] || (_cache[7] = ($event: any) => (_ctx.focus())),
      onAfterLeave: _cache[8] || (_cache[8] = ($event: any) => (_ctx.forget()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "search-palette" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_text_field, {
                ref: "field",
                modelValue: _ctx.text,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.text) = $event)),
                autofocus: "",
                clearable: "",
                "hide-details": "",
                variant: "plain",
                density: "comfortable",
                "prepend-inner-icon": "mdi-magnify",
                placeholder: _ctx.$tt('search.placeholder'),
                onKeydown: [
                  _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.move(1)), ["prevent"]), ["down"])),
                  _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.move(-1)), ["prevent"]), ["up"])),
                  _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (_ctx.openActive($event)), ["prevent"]), ["enter"]))
                ]
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createVNode(_component_v_progress_linear, {
              active: _ctx.searching,
              indeterminate: "",
              color: "primary",
              height: "2"
            }, null, 8, ["active"]),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.short)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$tt('search.min-chars', {count: _ctx.MIN})), 1))
                : (!_ctx.sections.length && !_ctx.searching)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$tt('search.none', {text: _ctx.needle})), 1))
                  : (_openBlock(), _createBlock(_component_v_list, {
                      key: 2,
                      density: "compact",
                      class: "py-0"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: section.idea
                          }, [
                            _createVNode(_component_v_list_subheader, { class: "search-group" }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_8, _toDisplayString(section.name), 1),
                                _createElementVNode("span", _hoisted_9, [
                                  _createVNode(_component_ontos_count, {
                                    count: section.shown,
                                    hidden: section.hidden
                                  }, null, 8, ["count", "hidden"])
                                ])
                              ]),
                              _: 2
                            }, 1024),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.rows, (row) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: row.index,
                                href: row.href,
                                active: row.index === _ctx.active,
                                "data-row": row.index,
                                onClick: ($event: any) => (_ctx.pick($event, row)),
                                onMouseenter: ($event: any) => (_ctx.active = row.index)
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_10, [
                                    _createVNode(_component_ontos_colored_value, {
                                      option: row.option,
                                      form: "accent",
                                      class: "search-identifier"
                                    }, null, 8, ["option"]),
                                    (row.state)
                                      ? (_openBlock(), _createBlock(_component_ontos_colored_value, {
                                          key: 0,
                                          option: row.state,
                                          form: "dot",
                                          class: "search-state"
                                        }, null, 8, ["option"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (row.hit)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createVNode(_component_v_icon, {
                                          size: "x-small",
                                          class: "search-why-icon"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(row.hit.icon), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createElementVNode("span", _hoisted_12, _toDisplayString(row.hit.name), 1),
                                        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "search-why-sep" }, "·", -1)),
                                        (row.hit.option)
                                          ? (_openBlock(), _createBlock(_component_ontos_colored_value, {
                                              key: 0,
                                              option: row.hit.option,
                                              form: "chip"
                                            }, null, 8, ["option"]))
                                          : (row.hit.plain)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(row.hit.plain), 1))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                                _createTextVNode(_toDisplayString(row.hit.before), 1),
                                                _createElementVNode("mark", null, _toDisplayString(row.hit.match), 1),
                                                _createTextVNode(_toDisplayString(row.hit.after), 1)
                                              ]))
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["href", "active", "data-row", "onClick", "onMouseenter"]))
                            }), 128))
                          ], 64))
                        }), 128))
                      ]),
                      _: 1
                    }))
            ], 512),
            (!_ctx.short)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$tt('search.hints')), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "fullscreen"])
  ], 64))
}